<div class="flex justify-center my-20 px-4">
  <div class="container mx-auto">
    <div class="flex flex-col items-center mb-10 text-center">
      <span class="text-[var(--primary)] font-bold text-sm uppercase tracking-widest mb-2">Explore Styles</span>
      <h2 class="text-4xl font-extrabold text-gray-900">
        Shop By Category
      </h2>
    </div>
    <div
      class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 mx-auto"
    >
      @for (cat of categories; track $index) {
         <app-category (click)="goToCategory(cat)" [name]="cat"></app-category>
      }
    </div>
  </div>
</div>
